import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  Subject,
  Language,
  School,
  Grade,
  Category,
} from '../../types/masterTypes';

interface MasterState {
  subjects: Subject[];
  languages: Language[];
  schools: School[];
  grades: Grade[];
  categories: Category[];
}

const initialState: MasterState = {
  subjects: [],
  languages: [],
  schools: [],
  grades: [],
  categories: [],
};

const masterSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {
    setSubjects: (state, action: PayloadAction<Subject[]>) => {
      state.subjects = action.payload;
    },
    setLanguages: (state, action: PayloadAction<Language[]>) => {
      state.languages = action.payload;
    },
    setSchools: (state, action: PayloadAction<School[]>) => {
      state.schools = action.payload;
    },
    setGrades: (state, action: PayloadAction<Grade[]>) => {
      state.grades = action.payload;
    },
    setCategories: (state, action: PayloadAction<Category[]>) => {
      state.categories = action.payload;
    },
  },
});

export const {setSubjects, setLanguages, setSchools, setGrades, setCategories} =
  masterSlice.actions;
export default masterSlice.reducer;
